export { SortableModule } from './sortable.module';
export { SortableComponent, SortableItem } from './sortable.component';
export { DraggableItemService } from './draggable-item.service';
export { DraggableItem } from './draggable-item';



// WEBPACK FOOTER //
// ./src/sortable/index.ts